<template>
  <validation-observer
    ref="saveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="editModal"
      size="lg"
      body-class="position-static"
      centered
      title="Chỉnh sửa đáp án trả lời"
      @show="onShow"
      @hide="onHide"
      :no-close-on-backdrop="true"
    >
      <b-form>
        <b-row>
          <b-col cols="4">
            <b-form-group label-for="name">
              <template v-slot:label>
                Tên đáp án <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Tên đáp án"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="targetDataSource.name"
                  name="name"
                  placeholder="Nhập tên đáp án"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="orderNo">
              <template v-slot:label>
                Thứ tự đáp án <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Thứ tự đáp án"
                rules="required"
              >
                <b-form-input
                  disabled
                  id="orderNo"
                  v-model="targetDataSource.orderNo"
                  name="orderNo"
                  placeholder="Thứ tự đáp án"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label-for="score">
              <template v-slot:label>
                Điểm cho đáp án <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Điểm cho đáp án"
                rules="required"
              >
                <b-form-input
                  id="score"
                  v-model="targetDataSource.score"
                  name="score"
                  placeholder="Điểm cho đáp án"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="3"
          >
            <b-form-group label-for="isCorrect">
              <b-form-checkbox
                v-model="targetDataSource.isCorrect"
                class="mt-3"
                value="1"
                unchecked-value="0"
              >
                Là đáp án đúng
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col
            cols="3"
          >
            <b-form-group label-for="multiple">
              <b-form-checkbox
                v-model="targetDataSource.multiple"
                class="mt-3"
                value="1"
                unchecked-value="0"
              >
                Có nhiều đáp án
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label-for="content">
              <template v-slot:label>
                Nội dung đáp án <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Nội dung đáp án"
              >
                <b-form-textarea
                  id="content"
                  v-model="targetDataSource.content"
                  name="content"
                  placeholder="Nội dung đáp án"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('editModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
        no-wrap
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BForm, BModal, BOverlay, BButton, BFormGroup, BFormInput, BRow, BCol, BFormTextarea, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { mapActions } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'

export default {
  name: 'Save',
  components: {
    BFormCheckbox,
    BFormTextarea,
    // eslint-disable-next-line vue/no-unused-components
    Cleave,
    BCol,
    BRow,
    BFormInput,
    ValidationProvider,
    BFormGroup,
    BModal,
    BForm,
    BOverlay,
    BButton,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    dataForm: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      targetDataSource: {
        id: null,
        qbQuestionId: null,
        code: '',
        name: '',
        content: '',
        multiple: 0,
        isCorrect: 0,
        score: 0,
        orderNo: 1,
      },
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        status: 1,
      },
      required,
      editorConfig: {
        versionCheck: false,
      },
      qbQuestionTypes: [],
      qbQuestionScales: [],
    }
  },
  computed: {
  },
  methods: {
    ...mapActions({
      updateDataSource: 'qbAnswer/updateMultipleAnswerDataSource',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      if (this.dataForm) {
        this.targetDataSource = { ...this.dataForm }
      }
    },
    onHide() {
      this.$refs
        .saveFormRef
        .reset()
      this.targetDataSource = {
        id: null,
        qbQuestionId: null,
        code: '',
        name: '',
        content: '',
        multiple: 0,
        isCorrect: 0,
        score: 0,
        orderNo: 1,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .saveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = await this.updateDataSource(this.targetDataSource)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('editModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>
